import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '../../../components/ui/button';
import { ArrowLeft, FileDown, FileText, FileSpreadsheet } from 'lucide-react';
import { toast } from 'sonner';
import { downloadPdf, downloadFile } from '../../../lib/download';
import { SatisfactionDialog } from '../SatisfactionForm';
import { LoadingCard, fmtDate } from '../shared';
import { BilanEntete } from './BilanEntete';
import { BilanIndicateurs } from './BilanIndicateurs';
import { BilanObservations } from './BilanObservations';
import { BilanChrono } from './BilanChrono';
import { BilanCandidats } from './BilanCandidats';
import { BilanSatisfaction } from './BilanSatisfaction';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BilanGeneralView = ({ dossierId, bilanId, onBack }) => {
  const [data, setData] = useState(null);
  const [sat, setSat] = useState(null);
  const load = useCallback(() => axios.get(`${API_URL}/bilans/${dossierId}/${bilanId}`).then(r => setData(r.data)).catch(() => toast.error('Erreur lors du chargement du bilan')), [dossierId, bilanId]);
  useEffect(() => { load(); }, [load]);
  if (!data) return <LoadingCard />;
  const b = data.bilan;
  return (
    <div className="space-y-4" data-testid="bilan-general-view">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div className="flex items-center gap-3">
          <Button type="button" variant="outline" size="sm" onClick={onBack} data-testid="bilan-back-btn"><ArrowLeft className="w-4 h-4 mr-1.5" /> Liste des bilans</Button>
          <h3 className="text-base font-semibold text-slate-800">Bilan {b.type === 'final' ? 'final' : 'intermédiaire'} du {fmtDate(b.date_bilan)}</h3>
        </div>
        <div className="flex items-center gap-2">
          <Button type="button" size="sm" variant="outline" onClick={() => downloadFile(`${API_URL}/bilans/${dossierId}/${bilanId}/export-xlsx`, `synthese_bilan_${b.type}_${data.dossier.code}_${b.date_bilan}.xlsx`, undefined, 'Excel')} data-testid="bilan-xlsx-btn"><FileSpreadsheet className="w-4 h-4 mr-1" /> Excel (synthèse)</Button>
          <Button type="button" size="sm" variant="outline" onClick={() => downloadFile(`${API_URL}/bilans/${dossierId}/${bilanId}/export-docx`, `bilan_${b.type}_${data.dossier.code}_${b.date_bilan}.docx`, undefined, 'Word')} data-testid="bilan-docx-btn"><FileText className="w-4 h-4 mr-1" /> Word (éditable)</Button>
          <Button type="button" size="sm" className="bg-indigo-600 hover:bg-indigo-700" onClick={() => downloadPdf(`${API_URL}/bilans/${dossierId}/${bilanId}/export-pdf`, `bilan_${b.type}_${data.dossier.code}_${b.date_bilan}.pdf`)} data-testid="bilan-pdf-btn"><FileDown className="w-4 h-4 mr-1" /> PDF du bilan</Button>
        </div>
      </div>
      <BilanEntete data={data} />
      <BilanIndicateurs data={data} />
      <BilanObservations dossierId={dossierId} data={data} onSaved={load} />
      <BilanChrono chronologie={data.chronologie} />
      <BilanCandidats dossierId={dossierId} data={data} onSaved={load} onSatisfaction={(cand) => setSat({ cible: 'candidat', candidat: cand })} />
      <BilanSatisfaction data={data} onSaisirEntreprise={() => setSat({ cible: 'entreprise' })} />
      {sat && <SatisfactionDialog open onOpenChange={(o) => !o && setSat(null)} dossierId={dossierId} cible={sat.cible} candidat={sat.candidat} clientId={data.dossier.client_id} questions={data.questions} onSaved={load} />}
    </div>
  );
};
